import { render, staticRenderFns } from "./ClasificacionArtistasPorPopularidad.vue?vue&type=template&id=27b92415&"
import script from "./ClasificacionArtistasPorPopularidad.vue?vue&type=script&lang=js&"
export * from "./ClasificacionArtistasPorPopularidad.vue?vue&type=script&lang=js&"
import style0 from "./ClasificacionArtistasPorPopularidad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports